<template>
  <v-dialog v-model="show" persistent max-width="700px">
    <v-card :class="classContents">
      <v-card-title>
        <h3>Edit Kpi Threshold</h3>
        <v-spacer></v-spacer>
        <v-btn icon x-small @click="closeComp()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-if="isShow">
        <v-row class="mx-3 mt-3">
          <v-col cols="12" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.description') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.message" class="w-auto" outlined dense :disabled="true" :hide-details="true"></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.warning') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.warningValue" class="w-auto" outlined dense type="number"></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.critical') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.criticalValue" class="w-auto" outlined dense type="number"></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.count') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.collectCount" class="w-auto" outlined dense type="number"></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.decimalFormat') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="formData.unitSymbol" class="w-auto" outlined dense :disabled="true"></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.active') }}</span>
              </div>
              <div class="float-left column-contents chk-min-con">
                <v-checkbox v-model="copyFormData.active" :disabled="copyFormData.active === undefined" class="alert-chk-mgt" dense></v-checkbox>
              </div>
            </div>
          </v-col>
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.continuousAlert') }}</span>
              </div>
              <div class="float-left column-contents chk-min-con">
                <v-checkbox v-model="copyFormData.continuousAlert" :disabled="copyFormData.continuousAlert === undefined" class="kpi-chk-mgt" dense></v-checkbox>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.failback') }}</span>
              </div>
              <div class="float-left column-contents chk-min-con">
                <v-checkbox v-model="copyFormData.failback" :disabled="copyFormData.failback === undefined" class="alert-chk-mgt" dense></v-checkbox>
              </div>
            </div>
          </v-col>
          <v-col cols="6" class="pr-5">
            <div class="my-1" v-if="isShowAlertUserBtn">
              <v-btn @click="openAlertUser()" small color="primary">{{ this.$t('alert.user.settings') }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="save()" :loading="loading" small color="primary">{{ this.$t('common.save') }}</v-btn>
        <v-btn @click="closeComp()" small color="primary">{{ this.$t('common.cancel') }}</v-btn>
      </v-card-actions>
      <AlertUser ref="kpiAlertUserComp" :userFormData="copyFormData" uiType="kpi" />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import AlertUser from './components/AlertUser';

export default {
  name: 'KpiForm',
  components: {
    AlertUser,
  },
  props: {
    formData: Object,
  },
  data() {
    return {
      show: false,
      loading: false,
      isShow: false,
      copyFormData: {},
    };
  },
  computed: {
    ...mapState('preference/alert', ['updateStatus']),
    isShowAlertUserBtn() {
      return this.formData.systemId !== '*' ? true : false;
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  watch: {
    updateStatus() {
      this.closeComp();
    },
    show(val) {
      if (val) this.copyPropdata();
    },
    copyFormData() {
      this.isShow = true;
    },
  },
  methods: {
    async copyPropdata() {
      this.copyFormData = await { ...this.formData };
    },
    resetDatas() {
      this.isShow = false;
    },
    closeComp() {
      this.resetDatas();
      this.show = false;
    },
    openAlertUser() {
      this.$refs.kpiAlertUserComp.$data.userShow = true;
    },
    save() {
      this.$store.dispatch('preference/alert/updateKpiThreshold', this.copyFormData);
    },
  },
};
</script>
